import React from 'react'
import { emailIsValid } from 'utils'

export default ({
    value = '', 
    handleChange,
    type
}) => {
    const invalid = type === 'email' && value && !emailIsValid(value)

    return (
        <input
            type="text"
            className={invalid ? 'invalid' : ''}
            value={value}
            onChange={e => handleChange(e.target.value)}
        />
    )
}